import { FulfillmentsApiClient } from '@fourthwall/services/dist/FulfillmentsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUploadFulfillmentsCSVMutation = createMutationHook(
  FulfillmentsApiClient.uploadCsv,
  {
    mutationKey: ['uploadFulfillmentsCSV'],
  },
)
